// extracted by mini-css-extract-plugin
export default {"anchor":"anchor_anchor__yQ0tH","white":"anchor_white__KEl+h","center":"anchor_center__rflpr"};